<template>
  <v-container
    fluid
    class="help-page"
  >
    <div
      ref="content"
      class="help-page__content"
    >
      <p
        v-if="message"
        class="help-page__content__error"
      >
        {{ message }}
      </p>
    </div>
  </v-container>
</template>

<script>
import { apiGetHelpHTML } from '@/api/api'
import { mapActions } from 'vuex'

export default {
  name: 'HelpPage',

  data () {
    return {
      message: ''
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.changeTab(2)
    })
  },

  async mounted () {
    this.message = 'Загрузка...'
    const html = await apiGetHelpHTML()

    if (!html) {
      this.message = 'Не удалось получить справку'
    }

    if (html && this.$refs.content) {
      this.message = ''
      this.$refs.content.innerHTML = html
    }
  },

  methods: {
    ...mapActions(['changeTab'])
  }
}
</script>

<style lang="scss">
  .help-page {
    display: flex;
    justify-content: center;
    padding: 40px 5vw;

    &__content {
      width: 100%;
      max-width: 1000px;
      border-radius: $default-border-radius;

      & > * {
        padding: 10px;
      }

      &__error {
        width: 100%;
        text-align: center;
      }
    }
  }
</style>
